import React, { useState } from "react";
import CDataGrid from "../../components/CDataGrid";
import CButton from "../../components/CButton";
import { ReactComponent as DeleteIcon } from "../../assets/images/trash-icon.svg";
import { useForm } from "react-hook-form";
import CFormProvider from "../../components/HookFormComponents/CFormProvider";
import CFormTextField from "../../components/HookFormComponents/CFormTextField";
import { useParams } from "react-router-dom";
import CTabs from "../../components/CTabs";
import { addTrainingForm } from "../../slices/trainingFormSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { ROWS_PER_PAGE_OPTIONS } from "../../constant/utils/commonUtils";
import { currentDate } from "../../constant/utils/datetimeUtils";
import { messages } from "../../constant/alertMessages";

const EditTrainingNeeds = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("Training Needs Forms");
  const [searchQuery, setSearchQuery] = useState("");
  const [dialogState, setDialogState] = useState({
    show: false,
    id: null,
    type: "",
  });

  const dispatch = useDispatch();

  const tabs = [
    { label: "Training Needs Forms", value: "Training Needs Forms" },
    { label: "Comments", value: "Comments" },
  ];

  const localData = JSON.parse(localStorage.getItem("sdfUser"));

  const skillsColumns = [
    {
      field: "skillsRequired",
      headerName: "Skills Required",
      flex: 1,
      editable: true,
    },
    {
      field: "trainingType",
      headerName: "Training Type",
      flex: 1,
      editable: true,
    },
    {
      field: "priority",
      headerName: "Priority",
      flex: 1,
      editable: true,
    },
    {
      field: "skillRequirementMotivation",
      headerName: "Skill Requirement Motivation",
      flex: 1,
      editable: true,
    },
    {
      field: "desiredDate",
      headerName: "Desired Date of Completion",
      flex: 1,
      editable: true,
    },
  ];

  const skillsRows = [
    {
      id: 1,
      skillsRequired: "Time management",
      trainingType: "Short Course",
      priority: "High",
      skillRequirementMotivation: "For better management",
      desiredDate: "For better management",
    },
    {
      id: 2,
      skillsRequired: "Time management",
      trainingType: "Short Course",
      priority: "High",
      skillRequirementMotivation: "For better management",
      desiredDate: "For better management",
    },
    {
      id: 3,
      skillsRequired: "Time management",
      trainingType: "Short Course",
      priority: "High",
      skillRequirementMotivation: "For better management",
      desiredDate: "For better management",
    },
  ];

  // Example columns and rows
  const selectColumns = [
    {
      field: "trainingName",
      headerName: "Training Name",
      flex: 1,
      editable: true,
    },
    {
      field: "trainingType",
      headerName: "Training Type",
      flex: 1,
      editable: true,
    },
    {
      field: "trainingExpense",
      headerName: "Cost per Learner",
      flex: 1,
      editable: true,
    },
    {
      field: "trainingDescription",
      headerName: "Training Details",
      flex: 1,
      editable: true,
    },
    {
      field: "trainingProviderName",
      headerName: "Provider",
      flex: 1,
    },
    {
      field: "targetedSkills",
      headerName: "Targeted Skills",
      flex: 1,
      editable: true,
    },
    {
      field: "NQFAligned",
      headerName: "NQF Aligned",
      flex: 1,
      editable: true,
    },
    {
      field: "NQFLevel",
      headerName: "NQF Level",
      flex: 1,
      editable: true,
    },
    {
      field: "DesiredDateOfCompletion",
      headerName: "Desired Date of completion",
      flex: 1,
      editable: true,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      renderCell: () => (
        <div className="flex 2xl:gap-3 gap-2 items-center h-full">
          {/* Delete Button */}
          <CButton
            tooltip="Edit"
            tooltipPosition={"top"}
            className="!min-w-0 bg-red-100 text-blue-600 hover:bg-red-200 2xl:!h-[28px] 2xl:!w-[28px] !h-[24px] !w-[24px] !p-0 !rounded-[5px] inline-flex items-center justify-center"
          >
            <DeleteIcon className="!fill-red-500 !text-red-500" />
          </CButton>
        </div>
      ),
    },
  ];

  const selectRows = [
    {
      id: 1,
      trainingName: "ABC",
      trainingType: "Short Course",
      trainingExpense: "1000",
      trainingDescription: "ABC",
      trainingProviderName: "ABC",
      targetedSkills: "ABC",
      NQFAligned: "Yes",
      NQFLevel: "1",
      DesiredDateOfCompletion: "2021-01-01",
    },
    {
      id: 2,
      trainingName: "ABC",
      trainingType: "Short Course",
      trainingExpense: "1000",
      trainingDescription: "ABC",
      trainingProviderName: "ABC",
      targetedSkills: "ABC",
      NQFAligned: "Yes",
      NQFLevel: "1",
      DesiredDateOfCompletion: "2021-01-01",
    },
  ];
  const methods = useForm({
    defaultValues: {
      shortTermGoal: "",
      longTermGoal: "",
      AnyNotes: "",
    },
  });
  const onSubmit = (data) => {
    let isAllSkillsSelected = true;
    let required_skills = [
      {
        skillsRequired: "Security",
        trainingType: "2",
        priorityLevel: "High",
        skillsRequirementMotivation: "Security",
        selectedTrainings: [
          "155e0568-79a9-4400-b9ff-d7c034d7cd96",
          "155e0568-79a9-4400-b9ff-d7c034d7cd98",
        ],
      },
      {
        skillsRequired: "Development",
        trainingType: "1",
        priorityLevel: "Medium",
        skillsRequirementMotivation: "Development",
        selectedTrainings: [
          "200e0568-79a9-4400-b9ff-d7c034d7cd96",
          "259e0568-79a9-4400-b9ff-d7c034d7cd98",
        ],
      },
    ];
    // data.skillsDetail.forEach((skill) => {
    //   if (!skill.selectedTrainings.length) {
    //     isAllSkillsSelected = false;
    //   }
    //   required_skills.push(skill);
    // });
    // if (!isAllSkillsSelected) {
    //   toast.error(
    //     "Please select at least one skill requirement with respect to each skills."
    //   );
    //   return;
    // }

    const trainingForm = {
      short_term_goal: data.shortTermGoal?.trim(),
      long_term_goal: data.longTermGoal?.trim(),
      notes: data.AnyNotes?.trim(),
      emp_id: localData.id,
      updated_at: currentDate(),
    };
    dispatch(addTrainingForm({ trainingForm, required_skills })).then((res) => {
      if (!res.payload.error) {
        toast.success(messages.TRAINING_FORM_SUBMITTED_SUCCESSFULLY);
      } else {
        toast.error(messages.SOMETHING_WENT_WRONG);
      }
    });
  };

  return (
    <>
      <div>
        <h2 class="!font-[Poppins] xl:text-3xl xl:leading-3xl text-2xl leading-2xl text-blue-500 font-semibold">
          Training Needs Form
        </h2>
        <CTabs
          tabs={tabs}
          value={activeTab}
          onChange={setActiveTab}
          className="my-4"
        />
        <div className="border border-blue-200 bg-white rounded-lg p-6 mb-6 relative mt-6">
          <p className="bg-white text-lg font-semibold text-gray-700 mb-4 2xl:text-xl 2xl:leading-xl lg:text-base lg:leading-base text-sm leading-sm absolute top-[-16px] left-[16px] px-1">
            Employee Details
          </p>
          <div className="grid grid-cols-5 gap-2">
            <p className="2xl:text-base text-sm 2xl:leading-base leading-sm text-gray-700 font-medium">
              Employee ID: <span>101</span>
            </p>
            <p className="2xl:text-base text-sm 2xl:leading-base leading-sm text-gray-700 font-medium">
              Employee Name: <span>John Doe</span>
            </p>
            <p className="2xl:text-base text-sm 2xl:leading-base leading-sm text-gray-700 font-medium">
              Designation: <span>Operations</span>
            </p>
            <p className="2xl:text-base text-sm 2xl:leading-base leading-sm text-gray-700 font-medium ">
              Department: <span>Operational Executive</span>
            </p>
            <p className="2xl:text-base text-sm 2xl:leading-base leading-sm text-gray-700 font-medium">
              Manager Name: <span>Mark Joshi</span>
            </p>
          </div>
        </div>
        <div className="border border-blue-200 bg-white rounded-lg p-4 mb-6 relative mt-6">
          <p className="bg-white text-lg font-semibold text-gray-700 mb-4 2xl:text-xl 2xl:leading-xl lg:text-base lg:leading-base text-sm leading-sm absolute top-[-16px] left-[16px] px-1">
            Training Needs Details
          </p>
          <div className="mt-3">
            <p className="2xl:text-base text-sm 2xl:leading-base leading-sm text-gray-700 font-medium">
              Skills Requirement:
            </p>
            <div className="mt-2 border-r border-l border-b border-blue-200 bg-white rounded-lg overflow-hidden">
              <CDataGrid
                rows={skillsRows}
                columns={skillsColumns}
                idKey="id"
                pageSize={5}
                rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                // onCellEditCommit={(params) => {
                //   const { id, field, value } = params;
                //   const updatedRows = skillsRows.map(row => {
                //     if (row.id === id) {
                //       return { ...row, [field]: value };
                //     }
                //     return row;
                //   });
                //   setSkillsRows(updatedRows);
                // }}
                // processRowUpdate={(newRow, oldRow) => {
                //   const updatedRow = { ...newRow };
                //   // You can add validation or transformation logic here
                //   return updatedRow;
                // }}
                // experimentalFeatures={{ newEditingApi: true }}
              />
            </div>
          </div>
          <div className="mt-5">
            <div className="flex justify-between">
              <p className="2xl:text-base text-sm 2xl:leading-base leading-sm text-gray-700 font-medium">
                Selected Training:
              </p>
              <CButton className="!h-auto !p-0 text-blue-500 font-semibold !ml-auto !underline">
                Select Trainigs
              </CButton>
            </div>
            <div className="mt-2 border-r border-l border-b border-blue-200 bg-white rounded-lg overflow-hidden">
              <CDataGrid
                rows={selectRows}
                columns={selectColumns}
                idKey="id"
                pageSize={5}
                rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
              />
            </div>
          </div>

          <div className="mt-6">
            <CFormProvider
              methods={methods}
              onSubmit={methods.handleSubmit(onSubmit)}
              className="custom-input-group"
            >
              <div className="grid grid-cols-2 gap-4">
                <CFormTextField
                  name="shortTermGoal"
                  label="Short Term Goal"
                  placeholder="Short Term Goal"
                  rows={3}
                  multiline
                  className="training-textarea"
                />
                <CFormTextField
                  name="longTermGoal"
                  label="Long Term Goal"
                  placeholder="Long Term Goal"
                  rows={3}
                  multiline
                  className="training-textarea"
                />
                <CFormTextField
                  name="AnyNotes"
                  label="Any Notes"
                  placeholder="Any Notes"
                  rows={3}
                  multiline
                  className="training-textarea col-span-2"
                />
              </div>
              <div className="mt-4 flex justify-end gap-2">
                <CButton
                  type="button"
                  className="transparent text-blue-500 hover:bg-blue-500 hover:text-white border border-blue-500"
                >
                  Cancel
                </CButton>
                <CButton
                  type="submit"
                  className="bg-blue-500 text-white hover:bg-blue-700 border border-blue-500 hover:border-blue-700"
                >
                  Update
                </CButton>
              </div>
            </CFormProvider>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditTrainingNeeds;
